import { totemBasicTypes } from "./totemBasicTypes";

const initialState = {
  solicitudes: [],
  boxes: [],
  boxesTomados: [],
  opciones: [],
  subOpciones: [],
};

export const totemBasicReducer = (state = initialState, action) => {
  switch (action.type) {
    // Solicitudes
    case totemBasicTypes.getSolicitudes:
      return {
        ...state,
        solicitudes: action.payload,
      };
    case totemBasicTypes.deleteSolicitud:
      return {
        ...state,
        solicitudes: state.solicitudes.filter(
          (solicitud) => solicitud.id !== action.payload.id
        ),
      };
    case totemBasicTypes.tomarSolicitud:
      return {
        ...state,
        solicitudes: state.solicitudes.map((solicitud) =>
          solicitud.id === action.payload.id ? action.payload : solicitud
        ),
      };
    case totemBasicTypes.liberarSolicitud:
      return {
        ...state,
        solicitudes: state.solicitudes.map((solicitud) =>
          solicitud.id === action.payload.id ? action.payload : solicitud
        ),
      };
    // Boxes
    case totemBasicTypes.getBoxes:
      return {
        ...state,
        boxes: action.payload,
      };
    case totemBasicTypes.insertBox:
      return {
        ...state,
        boxes: [...state.boxes, action.payload],
      };
    case totemBasicTypes.updateBox:
      return {
        ...state,
        boxes: state.boxes.map((box) =>
          box.id === action.payload.id ? action.payload : box
        ),
      };
    case totemBasicTypes.deleteBox:
      return {
        ...state,
        boxes: state.boxes.filter((box) => box.id !== action.payload.id),
      };

    // Boxes Tomados
    case totemBasicTypes.getBoxesTomados:
      return {
        ...state,
        boxesTomados: action.payload,
      };
    case totemBasicTypes.tomarBox:
      return {
        ...state,
        boxesTomados: [...state.boxesTomados, action.payload],
      };
    case totemBasicTypes.liberarBox:
      return {
        ...state,
        boxesTomados: state.boxesTomados.filter(
          (boxTomado) => boxTomado.id !== action.payload.id
        ),
      };

    // Opciones
    case totemBasicTypes.getOpciones:
      return {
        ...state,
        opciones: action.payload,
      };
    case totemBasicTypes.insertOpcion:
      return {
        ...state,
        opciones: [...state.opciones, action.payload],
      };
    case totemBasicTypes.updateOpcion:
      return {
        ...state,
        opciones: state.opciones.map((opcion) =>
          opcion.id === action.payload.id ? action.payload : opcion
        ),
      };
    case totemBasicTypes.deleteOpcion:
      return {
        ...state,
        opciones: state.opciones.filter(
          (opcion) => opcion.id !== action.payload.id
        ),
      };

    // SubOpciones
    case totemBasicTypes.getSubOpciones:
      return {
        ...state,
        subOpciones: action.payload,
      };
    case totemBasicTypes.insertSubOpcion:
      return {
        ...state,
        subOpciones: [...state.subOpciones, action.payload],
      };
    case totemBasicTypes.updateSubOpcion:
      return {
        ...state,
        subOpciones: state.subOpciones.map((subOpcion) =>
          subOpcion.id === action.payload.id ? action.payload : subOpcion
        ),
      };
    case totemBasicTypes.deleteSubOpcion:
      return {
        ...state,
        subOpciones: state.subOpciones.filter(
          (subOpcion) => subOpcion.id !== action.payload.id
        ),
      };

    // Opciones Por Box
    case totemBasicTypes.insertOpcionPorBox:
      return {
        ...state,
        boxes: state.boxes.map((box) =>
          box.id === action.payload.id ? action.payload : box
        ),
      };

    default:
      return state;
  }
};